import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as examActions from 'modules/exam';
import * as currentStatusActions from 'modules/currentStatus';

import { ExamDetail, ExamDetailPi, ExamDetailTag } from 'components';

class CtExamDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingTargetByTag: false,
      isLoadingTarget: false,
      isLoadingPC: false,
      isLoadingEdu: false
    };

    this.onMoveScroll = this.onMoveScroll.bind(this);
  }

  componentDidMount() {
    this.onGetTargetListByTag(true);
    this.onGetInfectionFile(true);
    this.onGetInfectionPC(true);
    this.onGetEduHistory(true);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // 탭을 변경시에는 렌더 하지 않음(단 감염PC와 감염파일은 해야함)
    if (
      this.props.currentPath !== nextProps.currentPath &&
      nextProps.currentPath !== '/main/exam/infectionpc' &&
      nextProps.currentPath !== '/main/exam/leakfile'
    ) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      targetListByTag,
      infectionTarget,
      infectionPC,
      eduList,
      selectedExamSummaryNo,
      selectedExamList
    } = this.props;

    // 태그별 대상자 리스트
    if (
      // 감염 대상이 변경되었을때
      (targetListByTag.get('needReload') && !this.state.isLoadingTargetByTag) ||
      // parameter가 변경되었을때
      targetListByTag.get('param') !== prevProps.targetListByTag.get('param') ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // 훈련 리스트에서 선택된 항목이 변경되었을때
      selectedExamList !== prevProps.selectedExamList
    ) {
      this.onGetTargetListByTag(true);
    }

    // 감염 대상
    if (
      // 감염 대상이 변경되었을때
      (infectionTarget.get('needReload') && !this.state.isLoadingTarget) ||
      // parameter가 변경되었을때
      infectionTarget.get('param') !== prevProps.infectionTarget.get('param') ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // 훈련 리스트에서 선택된 항목이 변경되었을때
      selectedExamList !== prevProps.selectedExamList
    ) {
      this.onGetInfectionFile(true);
    }

    // 감염 PC
    if (
      // 감염 PC가 변경되었을때
      (infectionPC.get('needReload') && !this.state.isLoadingPC) ||
      // parameter가 변경되었을때
      infectionPC.get('parma') !== prevProps.infectionPC.get('parma') ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // 훈련 리스트에서 선택된 항목이 변경되었을때
      selectedExamList !== prevProps.selectedExamList
    ) {
      this.onGetInfectionPC(true);
    }

    // 교육 이력
    if (
      // 감염 PC가 변경되었을때
      (eduList.get('needReload') && !this.state.isLoadingEdu) ||
      // parameter가 변경되었을때
      eduList.get('parma') !== prevProps.eduList.get('parma') ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // 훈련 리스트에서 선택된 항목이 변경되었을때
      selectedExamList !== prevProps.selectedExamList
    ) {
      this.onGetEduHistory(true);
    }
  }

  // 태그별 대상자 리스트
  onGetTargetListByTag = async refresh => {
    const { currentPath, ExamActions, targetListByTag, selectedExamSummaryNo, selectedExamList } = this.props;
    if (!!!this.state.isLoadingTargetByTag) {
      this.setState({ isLoadingTargetByTag: true });

      if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/tag') {
        if (refresh || targetListByTag.get('totalPage') > targetListByTag.get('page')) {
          try {
            const offsetValue = refresh ? 0 : targetListByTag.getIn(['param', 'limit']) * targetListByTag.get('page');
            const param = {
              examNo: selectedExamSummaryNo,
              filter: JSON.stringify(targetListByTag.get('param').get('filter')),
              sort: JSON.stringify(targetListByTag.get('param').get('sort')),
              offset: offsetValue,
              limit: targetListByTag.get('param').get('limit'),
              refresh: !!refresh,
              tagNo: selectedExamList.get(0)
            };

            await ExamActions.getTargetListByTag(param);
          } catch (e) {
            console.log(e);
          }
        }
      }

      this.setState({ isLoadingTargetByTag: false });
    }
  };

  // 감염 대상 조회
  onGetInfectionFile = async refresh => {
    const { currentPath, ExamActions, infectionTarget, selectedExamSummaryNo, selectedExamList } = this.props;
    if (!!!this.state.isLoadingTarget) {
      if (refresh || infectionTarget.get('totalPage') > infectionTarget.get('page')) {
        try {
          this.setState({ isLoadingTarget: true });

          let examNo = selectedExamSummaryNo;
          let targetNo = null;
          let tagNo = null;
          // 전체 훈련에서 선택한 훈련정보 나옴
          if (selectedExamSummaryNo === 'all' && selectedExamList.size > 0) {
            examNo = selectedExamList.get(0);
            // 개별훈련에서 대상자 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/pi') {
            targetNo = selectedExamList.get(0);
            // 개별훈련에서 태그 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/tag') {
            tagNo = selectedExamList.get(0);
            //
          }

          if (examNo === 'all') {
            this.setState({ isLoadingTarget: false });
            ExamActions.clearInfectionTarget();
            return false;
          }

          const offsetValue = refresh ? 0 : infectionTarget.getIn(['param', 'limit']) * infectionTarget.get('page');
          const param = {
            examNo: examNo,
            filter: JSON.stringify(infectionTarget.get('param').get('filter')),
            sort: JSON.stringify(infectionTarget.get('param').get('sort')),
            offset: offsetValue,
            limit: infectionTarget.get('param').get('limit'),
            refresh: !!refresh
          };

          if (!!targetNo) {
            param['targetNo'] = targetNo;
          }

          if (!!tagNo) {
            param['tagNo'] = tagNo;
          }

          await ExamActions.getInfectionTarget(param);
          this.setState({ isLoadingTarget: false });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 감염 PC 조회
  onGetInfectionPC = async refresh => {
    const { currentPath, ExamActions, infectionPC, selectedExamSummaryNo, selectedExamList } = this.props;
    if (!!!this.state.isLoadingPC) {
      if (refresh || infectionPC.get('totalPage') > infectionPC.get('page')) {
        try {
          this.setState({ isLoadingPC: true });

          let examNo = selectedExamSummaryNo;
          let tagNo = null;
          // 전체 훈련에서 선택한 훈련정보 나옴
          if (selectedExamSummaryNo === 'all' && selectedExamList.size > 0) {
            examNo = selectedExamList.get(0);
            // 개별훈련에서 대상자 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/pi') {
            this.setState({ isLoadingPC: false });
            ExamActions.clearInfectionPC();
            return false;
            // 개별훈련에서 태그 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/tag') {
            tagNo = selectedExamList.get(0);
            //
          }

          if (examNo === 'all') {
            this.setState({ isLoadingPC: false });
            ExamActions.clearInfectionPC();
            return false;
          }

          const offsetValue = refresh ? 0 : infectionPC.getIn(['param', 'limit']) * infectionPC.get('page');
          const param = {
            examNo: examNo,
            filter: JSON.stringify(infectionPC.getIn(['param', 'filter'])),
            sort: JSON.stringify(infectionPC.getIn(['param', 'sort'])),
            offset: offsetValue,
            limit: infectionPC.getIn(['param', 'limit']),
            refresh: !!refresh
          };

          if (!!tagNo) {
            param['tagNo'] = tagNo;
          }

          await ExamActions.getInfectionPC(param);
          this.setState({ isLoadingPC: false });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 교육 이력 조회
  onGetEduHistory = async refresh => {
    const { currentPath, ExamActions, eduList, selectedExamSummaryNo, selectedExamList } = this.props;
    if (!!!this.state.isLoadingEdu) {
      if (refresh || eduList.get('totalPages') > eduList.get('page')) {
        try {
          this.setState({ isLoadingEdu: true });

          let examNo = selectedExamSummaryNo;
          let tagNo = null;
          // 전체 훈련에서 선택한 훈련정보 나옴
          if (selectedExamSummaryNo === 'all' && selectedExamList.size > 0) {
            examNo = selectedExamList.get(0);
            // 개별훈련에서 대상자 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/pi') {
            this.setState({ isLoadingEdu: false });
            ExamActions.clearEduHistory();
            return false;
            // 개별훈련에서 태그 선택시
          } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/tag') {
            tagNo = selectedExamList.get(0);
            //
          }

          if (examNo === 'all') {
            this.setState({ isLoadingEdu: false });
            ExamActions.clearEduHistory();
            return false;
          }

          const offsetValue = refresh ? 0 : eduList.getIn(['param', 'limit']) * eduList.get('page');
          const param = {
            examNo: examNo,
            filter: JSON.stringify(eduList.getIn(['param', 'filter'])),
            sort: JSON.stringify(eduList.getIn(['param', 'sort'])),
            offset: offsetValue,
            limit: eduList.getIn(['param', 'limit']),
            refresh: !!refresh
          };

          if (!!tagNo) {
            param['tagNo'] = tagNo;
          }

          await ExamActions.getEduHistory(param);
          this.setState({ isLoadingEdu: false });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  // 아이콘을 통한 스크롤 이동 처리
  onMoveScroll = id => {
    this.scroll.scrollTop(this[id].offsetTop - 15);
  };

  // 스크롤 ref 등록
  onRefRegister = (key, refObject) => {
    if (!!refObject) {
      this[key] = refObject;
    }
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 상세보기 보이기/숨기기
  onToggleDetailView = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.onToggleDetailView();
  };

  // [감염 대상] 상세 보기
  onToggleInfectionTarget = targetNo => {
    const { ExamActions, infectionTarget } = this.props;
    const array = infectionTarget.get('isOpen');
    const index = array.indexOf(targetNo);

    // (삭제) 상세 닫기
    if (index !== -1) {
      ExamActions.changeInfectionTarget({ name: 'isOpen', value: array.splice(index, 1) });
      // (추가) 상세 열기
    } else {
      ExamActions.changeInfectionTarget({ name: 'isOpen', value: array.push(targetNo) });
    }
  };

  render() {
    const {
      // 현재 url 경로
      currentPath,
      // 훈련 리스트에서 선택된 row
      selectedExamList,
      // 훈련 정보
      examSummaryByExamNo,
      // 훈련 정보
      examListByNo,
      // 선택한 훈련
      selectedExamSummaryNo,
      // [태그별] 대상자 리스트
      targetListByTag,
      // 감염 대상
      infectionTarget,
      // 감염 PC
      infectionPC,
      // 교육 이력
      eduList,
      // snackbar 메세지
      isSnackbar
    } = this.props;
    // function
    const {
      onMoveScroll,
      onRefRegister,
      onToggleSnackbar,
      onToggleDetailView,
      onGetTargetListByTag,
      onGetInfectionFile,
      onGetInfectionPC,
      onGetEduHistory,
      onToggleInfectionTarget
    } = this;
    const { isLoadingTargetByTag, isLoadingTarget, isLoadingPC, isLoadingEdu } = this.state;

    // 상세 정보 데이터
    let detailType = 'exam';
    let selectedDetailData = examSummaryByExamNo.get(String(selectedExamSummaryNo));

    //전체 훈련에서 감염PC, 감염 파일은 디테일이 나오지 않도록 수정
    if (
      selectedExamSummaryNo === 'all' &&
      (currentPath === '/main/exam/infectionpc' || currentPath === '/main/exam/leakfile')
    ) {
      selectedDetailData = undefined;
      // 전체 훈련에서 선택한 훈련정보 나옴
    } else if (selectedExamSummaryNo === 'all' && selectedExamList.size > 0) {
      selectedDetailData = examSummaryByExamNo.get(String(selectedExamList.get(0)));
      // 개별 훈련에서 대상자 선택시
    } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/pi') {
      detailType = 'pi';
      selectedDetailData = examListByNo.get(String(selectedExamList.get(0)));
      // 개별 훈련에서 태그 선택시
    } else if (selectedExamSummaryNo !== 'all' && selectedExamList.size > 0 && currentPath === '/main/exam/tag') {
      detailType = 'tag';
      selectedDetailData = examListByNo.get(String(selectedExamList.get(0)));
    }

    // 선택되는 상세 내용이 없을 경우
    if (!!!selectedDetailData) {
      detailType = 'exam';
    }

    return (
      // 훈련 정보
      (detailType === 'exam' && (
        <ExamDetail
          selectedDetailData={selectedDetailData}
          isLoadingTarget={isLoadingTarget}
          isLoadingPC={isLoadingPC}
          isLoadingEdu={isLoadingEdu}
          infectionTarget={infectionTarget}
          infectionPC={infectionPC}
          eduList={eduList}
          isSnackbar={isSnackbar}
          // function
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
          onToggleSnackbar={onToggleSnackbar}
          // 감염 대상 조회
          onGetInfectionFile={onGetInfectionFile}
          // 감염 PC 조회
          onGetInfectionPC={onGetInfectionPC}
          // 교육 이력 조회
          onGetEduHistory={onGetEduHistory}
          // 훈련 상세 보이기/숨기기
          onToggleDetailView={onToggleDetailView}
          // [감염 대상] 열기/닫기 function
          onToggleInfectionTarget={onToggleInfectionTarget}
        />
      )) ||
      // 훈련의 개인 결과
      (detailType === 'pi' && (
        <ExamDetailPi
          selectedDetailData={selectedDetailData}
          isLoading={isLoadingTarget}
          infectionTarget={infectionTarget.getIn(['data', 0])}
          isSnackbar={isSnackbar}
          // 훈련 유형
          attachExamType={!!examSummaryByExamNo
            .get(String(selectedExamSummaryNo)) && examSummaryByExamNo
              .get(String(selectedExamSummaryNo))
              .getIn(['attachData', 'attachExamType'])}
          // function
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
          onToggleSnackbar={onToggleSnackbar}
          // 훈련 상세 보이기/숨기기
          onToggleDetailView={onToggleDetailView}
        />
      )) ||
      // 훈련의 태그 결과
      (detailType === 'tag' && (
        <ExamDetailTag
          selectedDetailData={selectedDetailData}
          isSnackbar={isSnackbar}
          isLoadingTargetByTag={isLoadingTargetByTag}
          isLoadingTarget={isLoadingTarget}
          isLoadingPC={isLoadingPC}
          isLoadingEdu={isLoadingEdu}
          targetListByTag={targetListByTag}
          infectionTarget={infectionTarget}
          infectionPC={infectionPC}
          eduList={eduList}
          // 훈련 유형
          attachExamType={examSummaryByExamNo
            .get(String(selectedExamSummaryNo))
            .getIn(['attachData', 'attachExamType'])}
          // function
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
          onToggleSnackbar={onToggleSnackbar}
          // 태급별 대상자 리스트
          onGetTargetListByTag={onGetTargetListByTag}
          // 감염 대상 조회
          onGetInfectionFile={onGetInfectionFile}
          // 감염 PC 조회
          onGetInfectionPC={onGetInfectionPC}
          // 교육 이력 조회
          onGetEduHistory={onGetEduHistory}
          // 훈련 상세 보이기/숨기기
          onToggleDetailView={onToggleDetailView}
          // [감염 대상] 열기/닫기 function
          onToggleInfectionTarget={onToggleInfectionTarget}
        />
      ))
    );
  }
}

const mapStateToProps = state => ({
  examSummaryByExamNo: state.examSummary.get('examSummaryByExamNo'),
  examListByNo: state.examList.get('examListByNo'),
  isSnackbar: state.currentStatus.get('isSnackbar'),
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected']),
  selectedExamList: state.currentStatus.getIn(['examList', 'selected', 'noArray']),
  // 태그별 대상자 리스트
  targetListByTag: state.exam.get('targetListByTag'),
  // 감염 대상
  infectionTarget: state.exam.get('infectionTarget'),
  // 감염 PC
  infectionPC: state.exam.get('infectionPC'),
  // 교육 이력
  eduList: state.exam.get('eduList')
});

const mapDispatchToProps = dispatch => ({
  ExamActions: bindActionCreators(examActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtExamDetail);



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamDetail.js